import { render } from "./inventory_and_sales.vue?vue&type=template&id=44ddc9f0&scoped=true"
import script from "./inventory_and_sales.vue?vue&type=script&lang=js"
export * from "./inventory_and_sales.vue?vue&type=script&lang=js"

import "./inventory_and_sales.vue?vue&type=style&index=0&id=44ddc9f0&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ddc9f0"]])

export default __exports__